module.exports = __webpack_public_path__ + "static/img/loading.a38a9b5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = F7NO
// module chunks = 37